import { useRef, useState } from 'react'

import { Emoji } from 'emoji-picker-react'

import * as spriteIcons from 'assets/svg/sprite'

import style from './_message_options.module.scss'

interface MessageOptionsProps {
    message: any
    addReaction: (val: string, val2: string) => void
    recieved?: boolean
    hideOptionsForMedia?: boolean
}

const MessageOptions = ({
    message,
    recieved,
    addReaction,
    hideOptionsForMedia = false,
}: MessageOptionsProps) => {
    const [emojiOpen, setEmojiOpen] = useState(false)

    const emojiRef = useRef<HTMLDivElement>(null)
    const emojiTimeout = useRef<any>(null)

    const correctOverflows = (element: HTMLDivElement) => {
        const parent =
            element.parentElement?.parentElement?.parentElement?.parentElement
                ?.parentElement

        const button = element.parentElement
        const buttonRect = button?.getBoundingClientRect()
        const parentRect = parent?.getBoundingClientRect()
        const rect = element.getBoundingClientRect()

        if (buttonRect && parentRect) {
            const buttonRightX = buttonRect.x + buttonRect.width

            if (rect.left < parentRect.left) {
                element.style.left = '60px'
                element.style.right = 'auto'
                element.style.transform = 'translateX(0px)'
            } else if (rect.right > parentRect.right) {
                element.style.left = 'auto'
                element.style.right = '0'
                element.style.transform = `translateX(${
                    parentRect.width - buttonRightX + 20
                }px)`
            }

            if (rect.top < parentRect.top) {
                element.style.top = `${buttonRect.height}px`
            }

            if (rect.bottom > parentRect.bottom) {
                element.style.top = 'auto'
                element.style.bottom = `${buttonRect.height + 5}px`
            }
        }
    }

    const closeEmoji = () => {
        if (emojiRef.current) {
            clearTimeout(emojiTimeout.current)

            emojiTimeout.current = setTimeout(() => {
                emojiRef.current?.removeAttribute('style')
            }, 200)
        }

        setEmojiOpen(false)
    }

    const openEmoji = () => {
        if (emojiRef.current) {
            correctOverflows(emojiRef.current)
            setEmojiOpen(true)
        }
    }

    const addMessageReaction = (type: string) => {
        closeEmoji()
        addReaction(type, message.id)
    }

    if (!recieved || hideOptionsForMedia) {
        return null
    }

    return (
        <>
            <div
                className={`${style.more_options_overlay} ${
                    emojiOpen ? style.more_options_overlay_open : ''
                }`}
                onClick={closeEmoji}
            />

            <div
                className={`${style.message_options_container} ${style.message_options_container_recieved}`}
            >
                <div className={style.message_options_react}>
                    <div
                        onClick={openEmoji}
                        className={style.message_options_react_icon}
                    >
                        <spriteIcons.IconHeartAddOutline />
                    </div>

                    <div
                        ref={emojiRef}
                        className={`${style.message_options_react_emojis} ${
                            emojiOpen
                                ? style.message_options_react_emojis_open
                                : ''
                        }`}
                    >
                        {[
                            ['love', '2764-fe0f'],
                            ['smile', '1f606'],
                            ['kiss', '1f618'],
                            ['cry', '1f972'],
                            ['sad', '1f614'],
                            ['like', '1f44d'],
                        ].map(([type, unified]) => (
                            <div
                                key={type}
                                onClick={() => {
                                    addMessageReaction(type)
                                }}
                            >
                                <Emoji unified={unified} size={25} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default MessageOptions